import { useQuery } from '@abyss/web/hooks/useQuery';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import GetProviderTypesSearch from './GetProviderTypesSearch.gql';

export const useProviderTypesSearch = (options) => {
  return useQuery(GetProviderTypesSearch, {
    ...options,
    url: ApiUrl.graphQl(),
    accessor: 'providerTypes',
  });
};
